import { Component } from 'react';
import Footer from "../Footer";

class FooterNL extends Component {
    render() {
      return (
          
        <Footer 
            contact={{
                title:"U kan ons bereiken", 
                email: { key:"Email", value:"info@coeladvocaten.be" },
                lines: [
                    { text:"" },      
                    { text:"Tel : +32 15 41 76 36"},
                    { text:"Fax : +32 15 43 21 55"},
                    { text:"" },                                                    
                    { text:"Onze burelen zijn open van 8:30 tot 17:30." },
                    { text:"Raadpleging enkel na afspraak" },
                    { text:"" },
                    { text:"BV Frank Coel Advocaat"},
                    { text:"Schuttersvest 78, 2800 Mechelen"},
                    { text:"KBO BE0861.086.519" },
                ]
            }}

            info={{
                title:"Wettelijke informatie", 
                lines: [
                    { text:"De advocaten zijn ingeschreven aan de balie van de Provincie Antwerpen." },
                    { text:"" },
                    { text:"De advocaten zijn verzekerd voor de beroepsaansprakelijkheid bij Amlin Europe NV, door bemiddeling van Vanbreda Risk & Benefits met polisnummer LXX034899." },
                    { text:"" },
                    { text:"Deze verzekering biedt een waarborg van 1.250.000,00 euro per schadegeval."},
                    { text:"" },
                    { text:"De cliënt is verantwoordelijk voor het verstrekken van alle informatie aangaande zijn dossier waarbij de vertrouwelijkheid van de informatie wordt gedekt door het beroepsgeheim van de advocaat."},
                ]
            }}

            links={{
                title:"Nuttige links", 
                items: [
                    { url:"/nl", name:"Home" },
                    { url:"/nl/frank-coel", name:"Frank Coel" },
                    { url:"/nl/anna-mamchenkova", name:"Anna Mamchenkova" },
                    { url:"/nl/bedrijven-in-moeilijkheden", name:"Bedrijf met moeilijkheden" },
                    { url:"/nl/advies-verdediging-geschillen", name:"Advies, verdediging en geschillen" },
                    { url:"/nl/publicaties", name:"Publicaties" },
                    { url:"/nl/pers", name:"Pers" },
                    { url:"/nl/algemene-voorwarden", name:"Tarieven" },
                    { url:"/nl/contact", name:"Contact" },
                ]
            }}

            articles={{
                title:"Pers", 
                items: [
                    { url:"/nl/pers#1", name:"Partijgenoot Somers leidt protest parking Schuttersvest" },
                    { url:"/nl/pers#2", name:"Grondvervuiling kan parking Schuttersvest tegenhoud" },
                    { url:"/nl/pers#3", name:"Brand gesticht om zus Olga te wreken" },
                    { url:"/nl/pers#4", name:"Illegaal kind (10) zonder familie in politiecel" },
                    { url:"/nl/pers#5", name:"Dossier Kucam is gebaseerd op geruchten" },
                    { url:"/nl/pers#6", name:"Ne zekere Frank in parlement regelt tegen betaling visa" },
                ]
            }}

            condition={{ url:"/nl/algemene-voorwarden", name:"Algemene voorwarden" }}
            privacy={{ url:"/nl/privacyverklaring", name:"Privacyverklaring" }}
            copyright="COELADVOCATEN - 78, Schuttersvest, 2800 Mechelen, Belgie"
            designer={{ url:"https://www.bewive.be", name:"Ontwerp bij Bewive", alt:"Naar de designwebsite" }}
            cookies={{ url:"/nl/privacyverklaring", name:"Privacyverklaring", text:"Door verder te bladeren op deze site, accepteert u het gebruik van cookies", button:"ik accepteer" }}
        />
          
      );
    }
  }
  
  export default FooterNL
